import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

import {
  HyphenIcon,
  Link,
  TextTooltip,
} from "@transfr-inc/dashboard-components";

import "./casting-link.scss";

import { isNullish } from "@lib/browser-utils";

export const CastingLink = ({ href, onClick, className }) => {
  if (isNullish(href) || !href) {
    return (
      <div className={clsx("casting-link", className)}>
        <HyphenIcon />
      </div>
    );
  }

  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.();
  };

  return (
    <Link
      className={clsx("casting-link", className)}
      href={href}
      target="_blank"
      underline={false}
      onClick={handleClick}
    >
      <TextTooltip text={href} className="casting-link-icon">
        <FontAwesomeIcon icon={["far", "screencast"]} />
      </TextTooltip>
    </Link>
  );
};
